var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"root"}},[_c('div',{class:_vm.cssClasses},[_c('router-view',{attrs:{"name":"content","title":_vm.title.toUpperCase(),"is-x-small":_vm.screen.isXSmall,"is-large":_vm.screen.isLarge}}),_c('GcHotKey')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }